import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { Box, IconButton, Typography, alpha, styled } from '@mui/material';
// components
import Iconify from '../../../../components/Iconify';
import { PATH_DASHBOARD } from '../../../../routes/paths';

// ----------------------------------------------------------------------

const RootStyle = styled(Box)(({ theme }) => ({
  position: 'fixed',
  right: 24,
  bottom: 24,
  zIndex: theme.zIndex.appBar + 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  pointerEvents: 'auto',
}));

const BadgeWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  cursor: 'pointer',
  '&:hover .badge-text': {
    transform: 'scale(1.1) rotate(-10deg)',
  },
}));

const BadgeText = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  top: -40,
  left: -20,
  width: 100,
  fontWeight: 900,
  fontSize: '14px',
  color: '#0EA5E9', // Cyan color from image
  transform: 'rotate(-15deg)',
  textShadow: '2px 2px 0 #fff, -2px -2px 0 #fff, 2px -2px 0 #fff, -2px 2px 0 #fff',
  transition: 'transform 0.3s ease',
  pointerEvents: 'none',
  userSelect: 'none',
}));

const ChatButton = styled(IconButton)(({ theme }) => ({
  width: 64,
  height: 64,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  boxShadow: `0 8px 32px ${alpha(theme.palette.primary.main, 0.3)}`,
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
    transform: 'scale(1.05)',
  },
}));

export default function YangaSupportBadge() {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <RootStyle>
      <BadgeWrapper onClick={() => navigate(PATH_DASHBOARD.general.support)}>
        <Box 
          className="badge-text"
          sx={{ 
            position: 'absolute', 
            top: -35, 
            left: -15, 
            zIndex: 1,
            pointerEvents: 'none'
          }}
        >
          <Typography 
            variant="caption" 
            sx={{ 
              fontWeight: 900, 
              color: '#0EA5E9', 
              fontSize: '16px',
              letterSpacing: 0.5,
              textTransform: 'uppercase',
              WebkitTextStroke: '1px white'
            }}
          >
            We Are Here!
          </Typography>
        </Box>
        
        <ChatButton>
          <Iconify icon="eva:message-circle-fill" width={32} height={32} />
        </ChatButton>

        <IconButton 
          size="small" 
          onClick={(e) => {
            e.stopPropagation();
            setIsVisible(false);
          }}
          sx={{ 
            position: 'absolute', 
            top: -10, 
            right: -10, 
            bgcolor: 'white', 
            boxShadow: 1,
            '&:hover': { bgcolor: '#f4f4f4' }
          }}
        >
          <Iconify icon="eva:close-fill" width={14} height={14} color="text.primary" />
        </IconButton>
      </BadgeWrapper>
    </RootStyle>
  );
}
